import request from "@/service";

// 期刊文章分页
export function articlePage(data) {
  return request({
    url: `/resource/periodical/article/page`,
    method: "post",
    data,
  });
}

// 期刊文章级联列表
export function articleCascade() {
  return request({
    url: `/resource/periodical/article/cascade`,
    method: "get",
  });
}

// 期刊文章详情
export function articleInfo(id) {
  return request({
    url: `/resource/periodical/article/info/${id}`,
    method: "get",
  });
}

/* 新增 */
export function articleSave(data) {
  return request({
    url: `/resource/periodical/article/save`,
    method: "post",
    data,
  });
}

/* 修改 */
export function articleUpdate(data) {
  return request({
    url: `/resource/periodical/article/update`,
    method: "put",
    data,
  });
}

/* 上下线 */
export function articleOnline(data) {
  return request({
    url: `/resource/periodical/article/online`,
    method: "put",
    data,
  });
}

/* 删除 */
export function articleDelete(data) {
  return request({
    url: `/resource/periodical/article/delete`,
    method: "delete",
    data,
  });
}

// 获取期刊文章列表
export function getNoRArticles() {
  return request({
    url: `/resource/periodical/article/getNoRArticles`,
    method: "get",
  });
}

// 修改期刊文章展示终端-shijunjian
export function updatePeriodicalArticleDisplay(data) {
  return request({
    url: `/resource/periodical/article/updatePeriodicalArticleDisplay`,
    method: "post",
    data,
  });
}
